import { render } from "./AddressForm.vue?vue&type=template&id=64d28d0c&ts=true"
import script from "./AddressForm.ts?vue&type=script&lang=ts&external"
export * from "./AddressForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__